export function initTeamtailor() {
  $(document).on('ajax:success', '.upload-to-teamtailor', event => {
    $(event.target).replaceWith("<i class='fal fa-external-link'></i> Uploaded to Teamtailor")
  });

  $(document).on('ajax:error', '.upload-to-teamtailor', event => {
    alert("There was an error pushing to Teamtailor")
  });
}
